import { render, staticRenderFns } from "./verifyWishDetail.vue?vue&type=template&id=bfc71508&scoped=true"
import script from "./verifyWishDetail.vue?vue&type=script&lang=js"
export * from "./verifyWishDetail.vue?vue&type=script&lang=js"
import style0 from "./verifyWishDetail.vue?vue&type=style&index=0&id=bfc71508&prod&lang=less&scoped=true"
import style1 from "./verifyWishDetail.vue?vue&type=style&index=1&id=bfc71508&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc71508",
  null
  
)

export default component.exports